var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-generator"},[_c('FormGenerator',{attrs:{"data":_vm.form,"isLoading":_vm.isLoading,"extra-item":_vm.mockItemProject,"extra-options":_vm.extraOptions},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }